export function QuantityControl({ value, max, onChange }: { value: number; max: number; onChange: (value: number) => void }) {
  return <div className="quantity-control">
    <button type="button" aria-label="Scade cantitatea" disabled={value <= 0} onClick={() => onChange(Math.max(0, value - 1))}>−</button>
    <strong>{value}</strong>
    <button type="button" aria-label="Crește cantitatea" disabled={value >= max} onClick={() => onChange(Math.min(max, value + 1))}>+</button>
  </div>;
}
